module.exports = __webpack_public_path__ + "img/14.e1c0987f.jpg";